import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKayakingNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M2 2.29C2 .285 4.423-.72 5.84.699l3.027 3.026c.85.85 1.091 2.064.747 3.122l1.272 1.272c6.6-5.824 14.136-7.542 17.747-8.05a2.89 2.89 0 013.298 3.298c-.508 3.611-2.226 11.147-8.05 17.747l.592.592a3.068 3.068 0 013.803.427l3.026 3.026C32.719 26.577 31.715 29 29.71 29h-1.533a5.56 5.56 0 01-3.96-1.655l-.272-.277a3.52 3.52 0 01-.921-3.275l-.872-.871-1.768-1.768-1.18-1.18-1.803-1.804-3.572-3.572-1.804-1.803-1.18-1.18L9.08 9.847 7.945 8.714c-1.313.64-2.929.41-4.013-.66l-.276-.273A5.56 5.56 0 012 3.823zm2.5.603v.93c0 .819.328 1.603.911 2.179l.277.272a1.02 1.02 0 001.378.05.567.567 0 00.033-.831zm8.158 6.998l1.034 1.034c1.03-.85 2.203-1.262 3.398-1.22 1.357.047 2.6.675 3.565 1.64.965.965 1.593 2.208 1.64 3.566.042 1.194-.37 2.367-1.22 3.397l1.035 1.034c5.286-6.058 6.875-12.974 7.345-16.323.025-.18-.033-.299-.104-.37-.071-.07-.19-.13-.37-.104-3.35.47-10.265 2.06-16.323 7.346zm6.636 6.636c.387-.54.519-1.063.503-1.53-.022-.62-.313-1.287-.91-1.884s-1.264-.888-1.885-.91c-.465-.016-.989.116-1.529.503zm8.884 9.973h.93l-2.6-2.599a.566.566 0 00-.832.033 1.02 1.02 0 00.05 1.379l.273.276a3.06 3.06 0 002.179.912zM.068 28.639C.554 25.18 2.151 18.11 7.412 11.716l1.777 1.777c-4.73 5.85-6.197 12.299-6.645 15.493-.025.18.033.298.103.367s.187.129.367.103c3.195-.448 9.643-1.914 15.493-6.645l1.777 1.777C13.89 29.85 6.82 31.447 3.362 31.932A2.886 2.886 0 01.068 28.64z" />
        <path d="M10.111 16.746c.18-.543.395-1.11.65-1.681l1.917 1.916c-.069.184-.133.369-.195.553-.444 1.338.645 2.427 1.984 1.983.183-.061.368-.126.552-.194l1.917 1.917c-.571.255-1.139.469-1.681.65-3.292 1.092-6.237-1.853-5.144-5.144z" />
      </g>
    </svg>
  )
);
SvgSportsKayakingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKayakingNormalMedium;
